import { Controller } from 'stimulus'
import { useDebounce } from 'stimulus-use'
import Rails from '@rails/ujs'

export default class extends Controller {
  static targets = ['searchBox', 'item', 'noResults', 'listContainer', 'submit']
  searchValue = ''

  // suggestionsUrl (optional) - if provided, uses ajax to call the URL for suggestions. If not provided, pre-loaded suggestions are used and filtered.
  static values = {
    submitDefaultLabel: String,
    submitCreateLabel: String,
    suggestionsUrl: String,
    showByDefault: Boolean
  }

  static debounces = ['search']

  connect() {
    addEventListener('select-multiple-component:dropdown-opened', () => {
      this.noResultsTarget.classList.add('hidden')
    })

    useDebounce(this)
    this.searchBoxTarget.addEventListener(`${this.identifier}:clear`, this.clear.bind(this), false)
  }

  disconnect() {
    this.searchBoxTarget.removeEventListener(`${this.identifier}:clear`, this.clear.bind(this), false)
  }

  triggerSearch(evt) {
    this.searchValue = evt.target.value

    if (this.hasSubmitTarget && this.submitDefaultLabelValue && !this.noResultsTarget.classList.contains('hidden')) {
      this.submitTarget.innerHTML = this.submitDefaultLabelValue
      delete this.searchBoxTarget.dataset.create
    }

    this.search(this.searchValue)
  }

  clear() {
    this.search('')
  }

  showNoResults(displayNoResults) {
    if (this.noResultsTarget === undefined) { return }

    if (displayNoResults) {
      if (this.hasSubmitTarget && this.submitCreateLabelValue) {
        this.submitTarget.innerHTML = this.submitCreateLabelValue + ' "' + this.searchValue + '"'
        this.searchBoxTarget.dataset.create = true
      }
      this.noResultsTarget.classList.remove('hidden')
    } else {
      this.noResultsTarget.classList.add('hidden')
    }
  }

  search(value) {
    if (this.suggestionsUrlValue) {
      this.lazyLoadSuggestions(value)
    } else {
      this.filterPreloadedSuggestions(value)
    }
  }

  initSuggestionsList() {
    if (this.showByDefaultValue) {
      this.itemTargets.forEach((item) => {
        item.classList.remove('hidden')
      })
      this.showNoResults(false)
    } else {
      this.itemTargets.forEach((item) => {
        item.classList.add('hidden')
      })
      this.showNoResults(true)
    }
  }

  lazyLoadSuggestions(value) {
    if (value.length === 0) {
      this.initSuggestionsList()
      return
    }

    const self = this
    Rails.ajax({
      type: 'get',
      url: this.suggestionsUrlValue,
      data: $.param({ query_string: value }),
      success: (response) => {
        const suggestions = response.getElementsByTagName('li')
        const noResults = suggestions.length === 0
        self.itemTargets.forEach((item) => { item.classList.add('hidden') })
        for (const suggestion of Array.from(suggestions)) {
          const existing = self.itemTargets.find(item => {
            return self.getValue(item) === self.getValue(suggestion)
          })
          if (existing) {
            existing.classList.remove('hidden')
            suggestion.parentNode.removeChild(suggestion)
          } else {
            self.listContainerTarget.insertAdjacentHTML('beforeend', suggestion.outerHTML)
          }
        }
        self.showNoResults(noResults)
      }
    })
  }

  filterPreloadedSuggestions(value) {
    let noResults = true
    const regex = new RegExp('.*' + value.toLowerCase() + '.*', 'gmi')
    this.itemTargets.forEach((item) => {
      if (item.getAttribute('data-search-filter-string').search(regex) >= 0) {
        item.classList.remove('hidden')
        noResults = false
      } else {
        item.classList.add('hidden')
      }
    })
    this.showNoResults(noResults)
  }

  getValue(li) {
    return li.getElementsByTagName('input')[0].value
  }
}
